import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Group from '@/components/Group'
import JoinUS from '@/components/JoinUS'
import Blockbuster from '@/components/Blockbuster'
import JoiningProcess from '@/components/JoiningProcess'
import StemClass from '@/components/StemClass'
import JoinQuery from '@/components/JoinQuery'
import DoubleClass from '@/components/DoubleClass'
import About from '@/components/About'
import Warning from '@/view/warning'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Group',
      name: 'Group',
      component: Group
    },
    {
      path: '/JoinUS',
      name: 'JoinUS',
      component: JoinUS
    },
    {
      path: '/Blockbuster',
      name: 'Blockbuster',
      component: Blockbuster
    },
    {
      path: '/joiningProcess',
      name: 'joiningProcess',
      component: JoiningProcess
    },
    {
      path: '/StemClass',
      name: 'StemClass',
      component: StemClass
    },
    {
      path: '/JoinQuery',
      name: 'JoinQuery',
      component: JoinQuery
    },
    {
      path: '/DoubleClass',
      name: 'DoubleClass',
      component: DoubleClass
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
     {
      path: '/Warning',
      name: 'Warning',
      component: Warning
    }
  ]
})
